import api from '../../api/index';
import wx from "weixin-js-sdk";
import router from '../../router/router';
import config from '../../../static/config.json';
import {
  Toast
} from 'vant';


// 通用 Module 
const state = {
  search: '', // 展品展馆搜索
  searchBy: '', // 展品输入框搜索
}
const mutations = { 
}
const getters = { 
}
const actions = { 
  getUrlQuery({
    rootGetters
  }) { // 获取url中的参数 
    return new Promise((resolve, reject) => {
      const query = router.history.current.query;
      const hostInviteId = query.hostInviteId;
      const backTo = query.backTo;
      const compId = query.compId; // 公司id
      const itemId = query.itemId || query.entranceId || rootGetters.getEntranceId; // 展会id
      const imgInviteId = query.imgInviteId; // 图片邀请函id
      const activityId = query.activityId; // 活动id 
      const url = {
        compId: compId,
        itemId: itemId,
        imgInviteId: imgInviteId,
        activityId: activityId,
        backTo: backTo,
        hostInviteId: hostInviteId
      };
      resolve(url);
    });
  },
  /**
   * 上传图片到微信服务器中
   * @param {*} {dispatch}
   * @param {*} opt {Type 0:展商logo 1:图片邀请函封面 2:纸质名片}
   * @returns
   */
  downWxPic({
    dispatch
  }, opt) { // 下载微信服务器上的图片  Type [ 0:展商logo 1:图片邀请函封面 2:纸质名片] 
    console.log('执行downWxPic');
    console.log('上传配置', opt);
    return new Promise((resolve, reject) => {
      api.post('/api/wxmaterialdownload', opt, {
          headers: {
            'api-version': 2
          }
        })
        .then(({
          data: {
            StatusCode,
            Data
          }
        }) => {
          // dispatch('dialog', {msg: '图片上传成功', bool: true});  
          resolve(true);
        })
        .catch(err => {
          // dispatch('dialog', {msg: '图片上传失败', bool: false});
          console.log(err);
        });
    });
  },
  /**
   * 上传图片   
   * @param {*} {commit, dispatch}  
   * @param {null} cb callback 执行的回调函数
   * @returns 微信返回的图片数据
   */
  async wxUpLoadImg({
    rootState,
    commit,
    dispatch
  }, cb = null) {
    const bool = await dispatch('wxShare/getConfig', {}, {root:true}); 
    dispatch('wxShare/wxHide', {}, { root: true });
    let localData = ''; // 图片本地的数据 可用于显示预览图  
    let MediaIds = ''; // 上传图片在微信里的 id
    return new Promise((resolve, reject) => {
      wx.ready(function () {
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            if (window.__wxjs_is_wkwebview === true) { // 兼容 iOS WKWebview 不支持 localId 直接显示图片的问题
              wx.getLocalImgData({
                localId: res.localIds[0], // 图片的localID
                success: function (res) { // localData是图片的base64数据，可以用img标签显示  
                  if (cb) cb(res.localData);
                }
              });
            } else { // 安卓 
              if (cb) cb(res.localIds[0]);
            }
            setTimeout(() => {
              wx.uploadImage({
                localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function (r) { 
                  console.log('上传成功了啊：', r);  
                  const loading = Toast.loading({
                    message: 'loading...',
                    forbidClick: true,
                  });
                  api.get(`${config.https.api}/api/v1/wechat/mediaid/convert?mediaId=${r.serverId}&ext=.jpg`, rootState.header).then(data => {
                    Toast.clear();
                    console.log(data,'图片data');
                    if (data.data.result) {
                      resolve(data.data.data);
                    } else {
                      console.log('图片上传服务器失败！');
                      resolve('');
                    }
                  }).catch((err) => {
                    console.log(err);
                  });

                  // resolve(dispatch('uploadImgToCloud', r.serverId));

                }
              });
            }, 100);
          },
          fail: function (res) {
            console.log(JSON.stringify(res));
          }
        });
      });
    });
  },
  uploadImgToCloud({
    rootState,
    commit
  }, id) { // 获取用户信息 
    return new Promise((resolve, reject) => { 
      api.get(`${config.https.api}/api/v1/wechat/mediaid/convert?mediaId=${id}&ext=.jpg`, rootState.header).then(data => { 
        if (data.data.result) {
          resolve(data.data);
        } else {
          console.log('图片上传服务器失败！');
          resolve('');
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}